const renderBlock = () => {
    return <div></div>;
};

export default renderBlock;
